export const COLONIA_SUBMIT = 'colonia_submit'
export const COLONIA_NOT_FOUND = 'colonia_not_found'
export const HOUSE_SIZE_SUBMIT = 'house_size_submit'
export const PREFERENCES_SUBMIT = 'preferences_submit'
export const DATETIME_SUBMIT = 'datetime_submit'
export const SEARCH_RESULTS = 'search_results'
export const ALIADA_VIEW_SUBMIT = 'aliada_view_submit'
export const ALIADA_CHOSEN_SUBMIT = 'aliada_chosen_submit'
export const ADDRESS_SUBMIT = 'address_submit'
export const SERVICE_SUMMARY_SUBMIT = 'service_summary_submit'
export const LOG_IN = 'log_in'
export const SIGN_UP = 'complete_registration'
export const PAYMENT_PROVIDER_TOKEN_GENERATION_SUCCESS = 'payment_provider_token_generation_success'
export const PAYMENT_PROVIDER_TOKEN_GENERATION_FAILURE = 'payment_provider_token_generation_failure'
export const SERVICE_CONFIRMATION_SUCCESS = 'success'
export const SERVICE_CONFIRMATION_FAILURE = 'service_confirmation_failure'



// WEBPACK FOOTER //
// ./src/services/Analytics/event-names.js